import BrowserCheck from 'components/BrowserCheck/BrowserCheck';
import EnvironmentLabel from 'components/EnvironmentLabel/EnvironmentLabel';
import ErrorBoundary from 'components/ErrorBoundary/ErrorBoundary';
import Footer from 'components/Footer/Footer';
import GoToTop from 'components/GoToTop/GoToTop';
import InfoBanner from 'components/InfoBanner/InfoBanner';
import SiteHeader from 'components/SiteHeader/SiteHeader';
import { CategoryItem } from 'frontend/types';
import React, { useEffect, useState } from 'react';
import styles from './Layout.module.css';
import classnames from 'classnames';
interface Props {
  children: React.ReactNode;
  categories: CategoryItem[];
  minorityLanguageCategories: CategoryItem[];
  customBackground?: boolean;
}
export const MAIN_CONTENT_ID = 'huvudinnehall';
export default function Layout({
  children,
  categories,
  customBackground,
  minorityLanguageCategories
}: Props) {
  const [renderBrowserCheck, setRenderBrowserCheck] = useState(false);
  useEffect(() => {
    setRenderBrowserCheck(true);
  }, []);
  return <div className={styles.mainBackground} data-sentry-component="Layout" data-sentry-source-file="Layout.tsx">
      <header>
        <EnvironmentLabel data-sentry-element="EnvironmentLabel" data-sentry-source-file="Layout.tsx" />
        <SiteHeader categoryMenuItems={categories} minorityLanguageCategories={minorityLanguageCategories} data-sentry-element="SiteHeader" data-sentry-source-file="Layout.tsx" />
        <InfoBanner data-sentry-element="InfoBanner" data-sentry-source-file="Layout.tsx" />
      </header>
      <main id={MAIN_CONTENT_ID} className={classnames(styles.main, {
      [`${styles.customBackground}`]: customBackground
    })}>
        <ErrorBoundary data-sentry-element="ErrorBoundary" data-sentry-source-file="Layout.tsx">
          <GoToTop data-sentry-element="GoToTop" data-sentry-source-file="Layout.tsx" />
          {children}
          {renderBrowserCheck && <BrowserCheck />}
        </ErrorBoundary>
      </main>
      <footer>
        <Footer data-sentry-element="Footer" data-sentry-source-file="Layout.tsx" />
      </footer>
    </div>;
}